export enum LibCircleState {
  Active,
  Visited,
  New,
}
